<div class="form-group">
  <label *ngIf="placeholder" [for]="name">{{placeholder | titlecase}}</label>
  <span class="p-fluid">
    <p-autoComplete (onUnselect)="eventChange($event)" (onSelect)="eventChange($event)" [(ngModel)]="model"
      [suggestions]="filtered" (completeMethod)="filter($event)" field="name" [multiple]="multiple" [dropdown]="true"
      [showEmptyMessage]="true" [forceSelection]="false" (onBlur)="onBlur($event)">
    </p-autoComplete>
  </span>
</div>